import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { PostNewsCalendarScheduleWeekRequest, PutNewsCalendarScheduleWeekRequest } from '../request/schedule-week';
import {
  PostNewsCalendarScheduleWeekResponse,
  GetNewsCalendarScheduleWeekResponse,
  PutNewsCalendarScheduleWeekResponse,
} from '../response/schedule-week';

export class ScheduleWeekService {
  static getScheduleWeeks(params?: QueryParams) {
    return apiClient.get<GetNewsCalendarScheduleWeekResponse>(buildApiUrl('/api/v1/news-calendar/schedule-week'), params);
  }

  static postScheduleWeek(data: PostNewsCalendarScheduleWeekRequest) {
    return apiClient.post<PostNewsCalendarScheduleWeekResponse>(buildApiUrl('/api/v1/news-calendar/schedule-week'), data);
  }

  static putScheduleWeek(id: string, data: PutNewsCalendarScheduleWeekRequest) {
    return apiClient.update<PutNewsCalendarScheduleWeekResponse>(buildApiUrl('/api/v1/news-calendar/schedule-week/:id', { id }), data);
  }

  static deleteScheduleWeek(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/news-calendar/schedule-week/:id', { id }), undefined);
  }
}
